import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=02d880ea"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports